<template>
    <div class="calendar-box">
        <div class="calendar-top-block">
            <div
                :class="['arrow-box', 'pre']"
                @click.stop="monthSelectUpdate(-1)">
                <span
                    :class="['calendar-arrow', 'pre']"
                    style="-webkit-mask: url('/static/img/common/prev.svg') no-repeat center / contain" />
            </div>
            <selects
                v-model="selectMonthData.values"
                :options="monthOptions"
                :multiple="selectMonthData.multiple"
                @change="monthSelect = $event[0]"
                @click.stop=""
                class="select-box"
                ref="select-ignore">
            </selects>
            <selects
                v-model="selectYearData.values"
                :options="yearOptions"
                :multiple="selectYearData.multiple"
                @change="yearSelect = $event[0]"
                @click.stop=""
                class="select-box"
                ref="select-ignore">
            </selects>
            <div
                :class="['arrow-box', 'next']"
                @click.stop="monthSelectUpdate(1)">
                <span
                    :class="['calendar-arrow', 'next']"
                    style="-webkit-mask: url('/static/img/common/prev.svg') no-repeat center / contain" />
            </div>
        </div>
        <transition name="fade">
            <div v-if="showDate">
                <div class="week-txt-row">
                    <span
                        v-for='week in weekTxt[local]'
                        :key="week"
                        class="week-txt">{{ week | shortHand(2) }}</span>
                </div>
                <div class="week-day-row">
                    <div
                        v-for='(day, index) in days'
                        :key="index"
                        :class="[
                            'date-block',
                            {
                                'disable-date': day.disabled,
                                'past-date-color': day.status === 'past',
                                'next-date-color': day.status === 'next',
                                'select-date-color': finalDate === day.value,
                                'today-color': today === day.value
                            }
                        ]"
                        @click.stop="selectCurrentDate(day)">
                        <span class="date select">{{ day.date }}</span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import selects from '@/components/common/Selects';
    import { isLeapYear } from "@/models/HELPERS/common.js";

    export default {
        name: 'CalendarBox',
        components: { selects },
        props: {
            selectDateStartTimeData: {
                type: Object,
                required: true,
                default: () => { return {} }
            },
            limitRange: {
                type: Object,
                required: true,
                default: () => { return {} }
            },
            formatYear: {
                type: String,
                required: false,
                default: 'twy'
            },
            local: {
                type: String,
                required: false,
                default: 'tw'
            },
        },
        data() {
            return {
                weekTxt: {
                    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    tw: ['日', '一', '二', '三', '四', '五', '六']
                },
                monthSelect: '',
                yearSelect: '',
                days: '',
                showDate: true,
                selectYearData: {
                    key:'year',
                    type: 'select',
                    placeholder: '請選擇',
                    values: [],
                    multiple: false
                },
                selectMonthData: {
                    key:'month',
                    type: 'select',
                    placeholder: '請選擇',
                    values: [],
                    multiple: false
                }
            }
        },
        computed: {
            today() {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1);
                const day = String(today.getDate());

                return `${year}-${month}-${day}`;
            },
            finalDate() {
                let selected_date = this.selectDateStartTimeData;
                return `${selected_date.year}-${selected_date.month}-${selected_date.date}`;
            },
            yearOptions() {
                const year_calculate = this.formatYear === 'twy' ? 1911 : 0;

                let current_year = new Date().getFullYear();
                let all_years = [current_year];
                for (let i = 1; i < 113; i++) {
                    all_years.push(current_year - i);
                    all_years.push(current_year + i);
                }
                all_years = all_years.sort((a, b) => { return a - b });
                return all_years.map(itme => {
                    return {
                        label: String(itme - year_calculate),
                        value: itme
                    }
                });
            },
            monthOptions() {
                let all_month = {
                    en: ['January', 'February', 'March', 'April', 'May', 'Jun', 'July', 'August', 'September', 'October', 'November', 'December'],
                    tw: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
                };
                return all_month[this.local].map((itme, index) => {
                    return {
                        label: String(itme),
                        value: index + 1
                    }
                });
            }
        },
        filters: {
            shortHand(data, num){
                return data.slice(0, num)
            }
        },
        watch: {
            monthSelect(month) {
                new Promise(resolve => {
                    this.showDate = false;
                    resolve()
                }).then(() => {
                    this.showDate = true;
                    this.renderDate();
                });
            },
            yearSelect(year) {
                new Promise(resolve => {
                    this.showDate = false;
                    resolve()
                }).then(() => {
                    this.showDate = true;
                    this.renderDate();
                });
            },
            selectDateStartTimeData(data) {
                if (data.year === '') {
                    return;
                }
                this.yearSelect = data.year;
                this.monthSelect = data.month;
                this.setSelectValues(this.yearSelect, this.monthSelect);
            }
        },
        mounted() {
            this.setYearAndMonthValue();
            this.renderDate();
        },
        methods: {
            setYearAndMonthValue() {
                this.monthSelect = new Date().getMonth() + 1;
                this.yearSelect = new Date().getFullYear();
                if (this.selectDateStartTimeData.year !== '') {
                    this.monthSelect = this.selectDateStartTimeData.month;
                    this.yearSelect = this.selectDateStartTimeData.year;
                }
                this.setSelectValues(this.yearSelect, this.monthSelect);
            },
            setSelectValues(year, month) {
                this.selectYearData.values = [parseInt(year)];
                this.selectMonthData.values = [parseInt(month)];
            },
            // 每月 1 號 禮拜幾
            weekDayStart() {
                let month = this.monthSelect;
                let year = this.yearSelect;
                let day = new Date(year, month -1, 1);
                return (day.getDay());
            },
            // 確認閏年
            isLeapYear(year) {
                return year % 4 === 0 || year % 400 === 0;
            },
            // 取得每月天數
            getMonthDaysNumber() {
                let month = this.monthSelect;
                let year = this.yearSelect;
                let is_leap_year = this.isLeapYear(year);
                let month_days = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                if (month === '2' && is_leap_year) {
                    return 29;
                } else if (month === '2' && !is_leap_year) {
                    return month_days[1];
                }
                return month_days[month - 1];
            },
            renderDate() {
                let total_days = this.getMonthDaysNumber();
                let week_day = this.weekDayStart();
                let year = this.yearSelect;
                let month = this.monthSelect;
                let month_days = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                let last_month_days = month_days[month -2];
                let days_array = [];
                month - 2 < 0 ? last_month_days = month_days[11] : '';

                // 上個月
                for (let i = 0; i < week_day; i++) {
                    let date = last_month_days - week_day + 1; // 每月最後一天也要算 所以 + 1
                    let month_copy = month;
                    let year_copy = year;
                    if (month_copy - 1 === 0) {
                        month_copy = 12;
                        year_copy--
                    } else {
                        month_copy--
                    }
                    let day_data = this.returnDayDate('past', year_copy, month_copy, date);
                    days_array.push(day_data);
                    last_month_days++
                }

                // 這個月
                for (let j = 1; j <= total_days; j++){
                    let day_data = this.returnDayDate('', year, month, j);
                    days_array.push(day_data);
                }

                let this_month_last = new Date(`${year}-${month}-${total_days}`);
                let next_month_first = this_month_last.getDay();
                let next_month_start = 0;
                // 下個月
                for (let i = next_month_first; i < 6; i++) {
                    let date = next_month_start + 1;
                    let month_copy = month;
                    let year_copy = year;
                    if (month_copy + 1 === 13) {
                        month_copy = 1;
                        year_copy++
                    } else {
                        month_copy++
                    }

                    let day_data = this.returnDayDate('next', year_copy, month_copy, date);
                    days_array.push(day_data);
                    next_month_start++
                }

                this.days = days_array;
            },
            returnDayDate(set_status = 'past', year, month, date) {
                let complete_time = year + '-' + month + '-' + date;
                let limit_start = this.limitRange.min.full_date;
                let limit_end = this.limitRange.max.full_date;
                let disable_date = false;

                if (this.limitRange.min.open) {
                    disable_date = new Date(complete_time).getTime() < new Date(limit_start).getTime();
                }
                if (this.limitRange.max.open) {
                    disable_date = new Date(complete_time).getTime() > new Date(limit_end).getTime();
                }
                if (this.limitRange.min.open && this.limitRange.max.open) {
                    disable_date = (new Date(complete_time).getTime() > new Date(limit_end).getTime()) || (new Date(complete_time).getTime() < new Date(limit_start).getTime());
                }

                return {
                    date: date,
                    status: set_status,
                    value: complete_time,
                    month: month,
                    year: year,
                    disabled: disable_date
                }
            },
            monthSelectUpdate(value) {
                this.monthSelect = this.monthSelect + value;
                if (this.monthSelect === 13) {
                    this.monthSelect = 1;
                    this.yearSelect++
                } else if (this.monthSelect === 0) {
                    this.monthSelect = 12;
                    this.yearSelect--
                }
                this.setSelectValues(this.yearSelect, this.monthSelect);
            },
            selectCurrentDate(day) {
                if (day.disabled) {
                    return;
                }
                this.$emit('choose-end', {
                    date: day.date,
                    month: day.month,
                    year: day.year
                });
            }
        }
    }
</script>
<style lang="sass" src="./calendar.sass" scoped></style>



// WEBPACK FOOTER //
// src/components/common/DatePicker/CalendarBox.vue